import { render, staticRenderFns } from "./summary_chart.vue?vue&type=template&id=36cbce5f&scoped=true&"
import script from "./summary_chart.vue?vue&type=script&lang=js&"
export * from "./summary_chart.vue?vue&type=script&lang=js&"
import style0 from "./summary_chart.vue?vue&type=style&index=0&id=36cbce5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cbce5f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
